<div class="generation-status">
  <section class="generation-status--section">
    <div class="generation-status__spinner" *ngIf="isInProgress()">
      <mat-spinner strokeWidth="5" diameter="32"></mat-spinner>
    </div>
    <mat-icon *ngIf="isFailed()" svgIcon="information-icon"></mat-icon>
    <div class="generation-status__text">
      {{ text() }}
    </div>
  </section>
</div>
